import React from 'react';
import { AgentConsoleNavigationSubheaderWrapper, SubheaderWrapper, MobileDealsSubheaderWrapper } from './styled';
import { SupportButton } from 'components/support/SupportButton';
import Breadcrumbs from 'components/agent-console/common/breadcrumbs';
import { useScreenBreakpoint } from 'consts/breakpoints';
import BackLink from 'components/navigation/BackLink';
import ArrowIcon from 'assets/svg/navigation/chevron-left.svg';
import { Text } from 'ds/components/typography';
import { useLocale } from 'locale';

const AgentConsoleNavigationSubheader: React.FC = () => {
  const { t } = useLocale();
  const isMobile = useScreenBreakpoint() < 3;

  if (isMobile) {
    return (
      <MobileDealsSubheaderWrapper>
        <AgentConsoleNavigationSubheaderWrapper>
          <SupportButton />
          <Text weight="medium">{t('dealsPage.header.mobile')}</Text>
          <BackLink>
            <ArrowIcon style={{ width: 8, height: 16 }} />
          </BackLink>
        </AgentConsoleNavigationSubheaderWrapper>
      </MobileDealsSubheaderWrapper>
    );
  }

  return (
    <SubheaderWrapper>
      <AgentConsoleNavigationSubheaderWrapper>
        <SupportButton />
        <Breadcrumbs />
      </AgentConsoleNavigationSubheaderWrapper>
    </SubheaderWrapper>
  );
};

export default AgentConsoleNavigationSubheader;
